var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[(_vm.block.value.image_url)?_c('a',{attrs:{"href":_vm.block.value.image_url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.block.value.image_url}})]):_vm._e(),_c('figcaption',[_vm._v(_vm._s(_vm.block.value.image_caption))])])}
var staticRenderFns = []

export { render, staticRenderFns }